import React from 'react';
import { Grid } from '@metarouter-private/mr-mui';

import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

import { BulkActionsMenu } from '@ion/ion-experimental';
import AnalyticsFilesCountTitle from './AnalyticsFilesCountTitle';

export default function AnalyticsFilesTableTitle() {
  const { analyticsFilesBulkDownloadUploadAlphaEnabled } = useFeatureEnabled(
    FEATURE_FLAGS.analyticsFilesBulkDownloadUploadAlpha
  );

  return (
    <Grid container spacing={1} alignItems="center">
      <Grid item flexGrow={1}>
        <AnalyticsFilesCountTitle />
      </Grid>
      {analyticsFilesBulkDownloadUploadAlphaEnabled && (
        <Grid item flexShrink={0}>
          <BulkActionsMenu />
        </Grid>
      )}
    </Grid>
  );
}
